module.exports = __webpack_public_path__ + "static/media/bar.ef20598e.csv";